import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import chart from './locales/en/chart.json';

export const i18n = createInstance({
  fallbackLng: 'en',
  lng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      chart,
    },
    ja: {
      chart,
    },
  },
});

i18n.use(initReactI18next).init();
